/** Player preferences — persisted on BOTH build variants (a few bytes of
 * localStorage; not part of "game saves"). Audio doesn't exist yet: these
 * values are the contract the sound system will honor when it lands. */

const SETTINGS_KEY = 'boomtown:settings';

export interface Settings {
  /** Master music volume 0..1. */
  musicVolume: number;
  musicOn: boolean;
  sfxOn: boolean;
}

const DEFAULTS: Settings = { musicVolume: 0.8, musicOn: true, sfxOn: true };

export function loadSettings(): Settings {
  try {
    const raw = globalThis.localStorage.getItem(SETTINGS_KEY);
    if (raw === null) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<Settings>;
    return {
      musicVolume: Math.max(0, Math.min(1, Number(parsed.musicVolume ?? DEFAULTS.musicVolume) || 0)),
      musicOn: parsed.musicOn !== false,
      sfxOn: parsed.sfxOn !== false,
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveSettings(next: Settings): void {
  try {
    globalThis.localStorage.setItem(SETTINGS_KEY, JSON.stringify(next));
  } catch {
    // Storage unavailable — settings just won't stick this session.
  }
}
